import { Component, effect, inject } from '@angular/core';
import { IndicatorStore } from '../../../stores/indicator/indicator.state';
import { DataLayerTypeNameComponent } from '../data-layer-type-name/data-layer-type-name.component';
import { DropdownModule } from 'primeng/dropdown';
import { NgIf } from '@angular/common';
import { SharedModule } from 'primeng/api';
import { GlobalsStore } from '../../../stores/globals.state';
import { Indicator } from '../../../models/indicator';
import { getState } from '@ngrx/signals';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-indicator-children-dropdown',
  standalone: true,
  imports: [
    DataLayerTypeNameComponent,
    DropdownModule,
    NgIf,
    SharedModule,
    FormsModule,
  ],
  templateUrl: './indicator-children-dropdown.component.html',
  styleUrl: './indicator-children-dropdown.component.scss',
})
export class IndicatorChildrenDropdownComponent {
  readonly globalStore = inject(GlobalsStore);
  readonly indicatorStore = inject(IndicatorStore);

  indicatorsToShow: Indicator[] = [];
  selection: Indicator | null = null;

  constructor() {
    effect(() => {
      const globalState = getState(this.globalStore);
      if (globalState.selectedIndicator) {
        this.indicatorsToShow = this.indicatorStore.filterByParent(
          globalState.selectedIndicator._id
        );
      }

      this.selection = globalState.selectedChildIndicator || null;
    });
  }

  onChange(indicator: Indicator) {
    this.globalStore.setSelectedChildIndicator(indicator);
  }
}
